import React, { useState } from "react";
import PropTypes from "prop-types";
// ui

// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import HeaderSystem from "./HeaderSystem";
// eslint-disable-next-line import/no-cycle
import ErrorCapture from "./ErrorCapture";
import ConfirmModalHoc from "./ConfirmModalHoc";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const TemplateSystem = ({ children }) => {
  // style
  const classes = useStyles();
  // props

  // local state

  return (
    <>
      <ErrorCapture>
        <HeaderSystem />
        <ConfirmModalHoc />
        {children}
      </ErrorCapture>
    </>
  );
};

TemplateSystem.propTypes = {
  children: PropTypes.node,
};

TemplateSystem.defaultProps = {
  children: null,
};

export default TemplateSystem;
